
import { Options, Vue } from "vue-class-component";

import ToggleV2 from "@/app/ui/components/toggle-v2/index.vue";
import { UrsaCodeDetail } from '@/domain/entities/OperationalArea';
import { OperationalAreaController } from '@/app/ui/controllers/OperationalAreaController';
import { MainAppController } from '@/app/ui/controllers/MainAppController';
import { formatDate, parsingErrorResponse } from '@/app/infrastructures/misc/Utils';
import qs from "qs";
@Options({
  components: {
    ToggleV2
  },
  computed: {
  }
})
export default class DetailUrsa extends Vue {
  ursaCodeDetailData = new UrsaCodeDetail();
  errorCause = "";
  isLoadingFetch = false;
  isError = false;

  mounted() {
    this.getUrsaCodeDetail();
  }

  get parsedId(): string {
    const parsed = qs.parse(location.search, { ignoreQueryPrefix: true, decoder(str) {
      return str.replace(/\+/g, '%2B'); // cegah + jadi spasi
    }});

    return parsed?.id as string || "";
  }

  get id(): string {
    return this.parsedId;
  }

  get ursaCodeTitle() {
    return decodeURIComponent(this.parsedId);
    //return this.$route.params.id?.toString()?.replace(/([A-Za-z]+)(\d+)/, '$1-$2')
  }

  get threeLetterCodeList() {
    return this.ursaCodeDetailData.threeLetterCode;
  }

  get areaList() {
    return this.ursaCodeDetailData.area;
  }

  get postalCodeList() {
    return this.ursaCodeDetailData.postalCode;
  }

  get createdAt() {
    if (this.ursaCodeDetailData.createdAt) return formatDate(this.ursaCodeDetailData.createdAt);
    return "-"
  }

  get updatedAt() {
    if (this.ursaCodeDetailData.updatedAt) return formatDate(this.ursaCodeDetailData.updatedAt);
    return "-"
  }

  async getUrsaCodeDetail() {
    try {
      this.isError = false;
      this.isLoadingFetch = true;
      this.ursaCodeDetailData = await OperationalAreaController.getUrsaDetail(this.id);
    } catch (error) {
      this.errorCause = parsingErrorResponse(error).type
      this.isError = true;
    } finally {
      this.isLoadingFetch = false;
    }
  }

  async updateUrsaStatus(status: boolean) {
    try {
      MainAppController.showLoading();
      await OperationalAreaController.updateUrsaStatus({ursaCode: this.id, status})
      this.getUrsaCodeDetail();
    } catch (error) {
      MainAppController.showErrorMessage(parsingErrorResponse(error));
    } finally {
      MainAppController.closeLoading();
    }
  }

  goBack() {
    this.$router.push("/network/operational-area");
  }
}
